export default "__VITE_ASSET__Djh468qr__"